/* eslint-disable react/no-unknown-property */
import { useEffect, useRef } from 'react'
import classnames from 'classnames/bind'
import { useAppSelector } from '@/redux/hooks'
import videojs from 'video.js'
import { isEmpty } from 'lodash-es'
import { useTranslation } from 'next-i18next'

// Libs
import useDevices from '@/hooks/useDevices'
import useVideoAction from '@/hooks/useVideoAction'
import { getVideoConstraints } from '@/methods/getVideoConstraints'

// Components
import Action from './components/Action'
import CameraOff from './components/CameraOff'
import Icon from '@/assets/icons'

// Styles
import 'video.js/dist/video-js.css'
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const Preview = () => {
  const { t } = useTranslation()

  const currentStreamRef: any = useRef<any>(null)
  const videoRef = useRef<any>(null)

  const mediaData = useAppSelector((state) => state.media.mediaData)
  const hasMediaAccess = useAppSelector((state) => state.media.hasAccess)
  const gdata = useAppSelector((state) => state.room.gdata)

  const currentVideoInputId = mediaData?.currentVideoInputId

  useDevices()
  const { isMicEnabled, isCameraEnabled, isDisabledCameraSwitch, isMultiCamera, handleMicStatus, handleCameraStatus, handleCameraSwitch } =
    useVideoAction({
      currentStreamRef,
    })

  useEffect(() => {
    if (!currentVideoInputId || isEmpty(gdata)) return

    const getUserMedia = async () => {
      const videoConstraints = getVideoConstraints({
        currentVideoInputId: mediaData?.currentVideoInputId,
        frameRate: gdata.videoInfo.frameRate,
        width: gdata.videoInfo.width,
        height: gdata.videoInfo.height,
      })
      console.log('shop', `getUserMedia ${JSON.stringify(videoConstraints)}`)

      navigator.mediaDevices
        .getUserMedia({
          audio: true,
          video: isCameraEnabled
            ? {
                ...videoConstraints,
              }
            : false,
        })
        .then((mediaStream) => {
          currentStreamRef.current = mediaStream

          const videoTrack = mediaStream.getVideoTracks()[0]
          if (videoTrack) {
            const settings = videoTrack.getSettings()
            const { width, height } = settings
            console.log('shop', `getUserMedia got video resolution: ${width} x ${height}`)
          }

          videojs(
            videoRef.current,
            {
              autoplay: true,
              muted: true,
              poster: '/images/mic-off@2x.png',
            },
            () => {
              console.log('shop', 'Player ready')
            },
          )

          if (mediaStream) {
            videoRef.current.srcObject = mediaStream
          }

          // 創建本地視訊元素，並將本地媒體流綁定到元素
        })
        .catch((error) => {
          console.error('shop', 'getUserMedia error：', error)
        })
    }

    getUserMedia()

    return () => {
      if (currentStreamRef.current) {
        currentStreamRef.current.getTracks().forEach((track: any) => {
          track.stop()
        })
      }
    }
  }, [currentVideoInputId, isCameraEnabled, gdata])

  return (
    <div className={cx('preview')}>
      <div className={cx('preview-player')}>
        <div className={cx('preview-player-item')} data-vjs-player>
          <video className={cx('preview-player-item-video')} ref={videoRef} webkit-playsinline='true' playsInline={true} x5-playsinline='true' />
        </div>

        {/* camera off */}
        {(!hasMediaAccess || !isCameraEnabled) && <CameraOff />}

        {hasMediaAccess && (
          <Action
            isMicEnabled={isMicEnabled}
            isCameraEnabled={isCameraEnabled}
            isDisabledCameraSwitch={isDisabledCameraSwitch}
            isMultiCamera={isMultiCamera}
            handleMicStatus={handleMicStatus}
            handleCameraStatus={handleCameraStatus}
            handleCameraSwitch={handleCameraSwitch}
          />
        )}
      </div>

      {!hasMediaAccess && (
        <div className={cx('preview-try')}>
          <div className={cx('preview-try-icon')}>
            <Icon.Attention />
          </div>
          <p className={cx('preview-try-text')}>{t('LiveRoom_Preview_Try_Error')}</p>
        </div>
      )}
    </div>
  )
}

export default Preview
